module.exports = __webpack_public_path__ + "static/protest-f8ac7e81b60e3aa08b5d25e3600293c7.jpeg";